<template>
  <div id="app" class="h100">

    <header class="only-mobile">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <h2>Tim Vogt</h2>
          </div>
          <div class="col text-right">
            <button
              @click.prevent="toggleNav"
              class="navToggle hamburger hamburger--minus"
              :class="{'is-active': navIsOpen}"
              type="button">
              <span class="hamburger-box">
                <span class="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
      </div>
    </header>

    <div class="container h100">
      <div class="row h100">
        <div class="col col-12 col-md-3">
          <navigation />
        </div>
        <div class="col col-12 col-md-8 offse-md-1">
          <router-view/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation";


export default {
  data() {
    return {
      offsetTop: 0,
      navIsOpen: false
    }
  },
  mounted() {
    window.onresize = () => {
      this.$bus.$emit('getTopNavSpace', {});
    }
    this.$bus.$on('setTopNavSpace', (data) => {
      this.offsetTop = data.top;
      this.scrollListener();
    });
    window.onscroll = this.scrollListener;
    this.$bus.$emit('getTopNavSpace', {});
    this.$bus.$on('toggleNav', (data) => {
      this.navIsOpen = data.isOpen;
    });
  },
  methods: {
    scrollListener() {
      let activeElement = '';
      const currOffset = window.scrollY + this.offsetTop;
      document.querySelectorAll('section').forEach((el) => {
        const active = (currOffset >= el.offsetTop);
        if (active) activeElement = el.id;
      })
      this.$bus.$emit('activeSection', { name: activeElement });
    },
    toggleNav() {
      this.$bus.$emit('toggleNav', { isOpen: !this.navIsOpen })
    }
  },
  components: {
    Navigation
  }
}
</script>

<style lang="sass">
@import "../node_modules/bootstrap-scss/bootstrap-grid.scss"
@import "../node_modules/bootstrap-scss/_media.scss"
@import "./assets/sass/_vars.sass"

$hamburger-layer-color: $colorPrimary
$hamburger-layer-height: 2px
$hamburger-layer-width: 34px
$hamburger-layer-spacing: 7px
$hamburger-padding-y: 23px
@import "../node_modules/hamburgers/_sass/hamburgers/hamburgers.scss"


html, .h100
  height: 100%
  margin-top: 0
  margin-bottom: 0


#app
  font-family: 'Avenir', Helvetica, Arial, sans-serif
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  color: #2c3e50
  // perspective: 400px


.container
  @media screen and (min-width: 992px)
    max-width: 800px

section
  margin-bottom: 3em

a
  color: #2c3e50

  &:hover
    text-decoration: none

header
  position: fixed
  display: block
  background-color: #FFFFFF
  top: 0
  left: 0
  right: 0
  z-index: 3
  border-bottom: 1px solid #EEE

  button
    z-index: 6

  @media screen and (min-width: 770px)
    display: none

.text-right
  text-align: right

.only-mobile
  @media screen and (min-width: 770px)
    display: none

ul.list
  list-style-type: none
  padding-left: 2em

  li:before
    content: '-'
    display: inline-block
    //padding-right: .5em
    margin-left: -1em
    width: 1em
    color: lighten($colorPrimary, 20%)


</style>
